import React, { useState } from 'react'
import { AuthSkyline } from '../components/common/AuthSkyline';
import { Helmet } from 'react-helmet-async';
import { HeaderContainer, LessonPageContainer, MainContentArea } from '../styles/lesson/layout.style'
import { CalendarIcon, CompletedIcon, NavButton, ResultsGrid } from '../styles/lesson/lesson.style';
import { LessonStats } from '../components/lessons/LessonStats';
import { FiBarChart2 } from 'react-icons/fi';
import { useEvents } from '../hooks/useEvents';
import { LoadingOverlay } from '../styles/search/search.style';
import { LessonList } from '../components/lessons/LessonList';
import { useScale } from './HeightScaler';
import { Area } from '../styles/_app.style';
import { NAVIGATION_HEIGHT } from '../constants/global';
import { TuteeLoader } from '../components/common/TuteeLoader';

const TOP_MARGIN = `(${NAVIGATION_HEIGHT})`

const LessonPage: React.FC = () => {
  const { scale } = useScale();
  const [activeTab, setActiveTab] = useState<'upcoming' | 'completed' | 'stats'>('upcoming');
  const { isLoading, events } = useEvents();

  return (
    <div style={{ position: 'relative' }}>
    <AuthSkyline light />
    <Helmet><title>Lessons - tute</title></Helmet>
    <Area
      css={{
        height: `calc((100dvh / ${scale}) - ${TOP_MARGIN})`,
        marginTop: `calc(${TOP_MARGIN})`,
      }}
    >
      <LessonPageContainer>
        <HeaderContainer>
          <NavButton
            active={activeTab === 'upcoming'}
            onClick={() => setActiveTab('upcoming')}
          >
            <CalendarIcon />
            Upcoming
          </NavButton>

          <NavButton
            active={activeTab === 'completed'}
            onClick={() => setActiveTab('completed')}
          >
            <CompletedIcon />
            Completed
          </NavButton>

          <NavButton
            active={activeTab === 'stats'}
            onClick={() => setActiveTab('stats')}
          >
            <FiBarChart2 />
            Stats
          </NavButton>
        </HeaderContainer>

        <MainContentArea style={{ position: 'relative' }}>
          <ResultsGrid>
            {isLoading && (
              <LoadingOverlay>
                <TuteeLoader />
              </LoadingOverlay>
            )}
            {!isLoading && activeTab !== 'stats' && (
              <LessonList
                events={events}
                mode={activeTab}
              />
            )}
            {!isLoading && activeTab === 'stats' && (
              <LessonStats events={events} />
            )}
          </ResultsGrid>
        </MainContentArea>
      </LessonPageContainer>
    </Area>
    </div>
  )
}

export default LessonPage